import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropTypes from 'prop-types';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import H2 from 'UIComponents/elements/headings/H2';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import { upgradeDataPropsInterface } from '../../data/upgradeData/interfaces/upgradeDataPropsInterface';
import { sourceKeys } from '../../data/upgradeData/properties/sources';
import { StyledModal } from '../StyledModal';
import ActivationSuccessFooter from './ActivationSuccessFooter';
const {
  TRIAL
} = sourceKeys;

const ActivationSuccessModal = ({
  ctaText,
  hideBackground,
  header,
  onSuccess = () => {},
  showIllustration,
  subText,
  type,
  showTrialLoadingState,
  showSubtitle,
  upgradeData,
  upgradeData: {
    upgradeProduct,
    apiName
  },
  canViewNewSeats
}) => {
  const isTrialModal = type === TRIAL;
  const eligibleForNewSeats = apiName && canViewNewSeats;
  const productLine = apiName ? apiName.split('-')[0] : upgradeProduct.split('-')[0];
  return /*#__PURE__*/_jsxs(StyledModal, {
    hideBackground: hideBackground,
    centered: true,
    size: "auto",
    use: "success",
    width: 600,
    "data-test-id": "activation-success-modal",
    children: [showIllustration && /*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: -30,
      offsetTop: 40,
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "success",
        width: 118
      })
    }), /*#__PURE__*/_jsx(UIDialogHeader, {
      className: showSubtitle ? 'p-bottom-2' : undefined,
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H2, {
          children: header || /*#__PURE__*/_jsx(FormattedMessage, {
            message: `upgrades.activationModal.${isTrialModal ? 'trialTitle' : 'productTitle'}`
          })
        }), showSubtitle && /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "m-top-4 m-bottom-2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.activationModal.trialSubtitle"
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "text-center",
            style: {
              fontWeight: parseInt(WEB_FONT_DEMI_BOLD_WEIGHT, 10)
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: eligibleForNewSeats ? `upgrades.products.${apiName}` : `upgrades.products.${upgradeProduct}`
            })
          })]
        })]
      })
    }), subText ? /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: subText
      })
    }) : /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        className: "text-left",
        direction: "column",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.globalContentBlock.title"
        }), /*#__PURE__*/_jsxs(UIList, {
          styled: true,
          children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "upgrades.activationModal.globalContentBlock.tryForFree",
            options: {
              productName: /*#__PURE__*/_jsx(FormattedMessage, {
                message: eligibleForNewSeats ? `upgrades.products.${apiName}` : `upgrades.products.${upgradeProduct}`
              })
            }
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.activationModal.globalContentBlock.getSupport"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.activationModal.globalContentBlock.browseHowTo"
          })]
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `upgrades.activationModal.dynamicContentBlock.${productLine}`
        })]
      })
    }), /*#__PURE__*/_jsx(ActivationSuccessFooter, {
      ctaText: ctaText,
      onSuccess: onSuccess,
      showTrialLoadingState: Boolean(showTrialLoadingState),
      upgradeData: upgradeData
    })]
  });
};

ActivationSuccessModal.defaultProps = {
  showIllustration: true,
  showSubtitle: false,
  showTrialLoadingState: false
};
ActivationSuccessModal.propTypes = Object.assign({
  ctaText: PropTypes.node,
  hideBackground: PropTypes.bool,
  header: PropTypes.node,
  onSuccess: PropTypes.func,
  showIllustration: PropTypes.bool,
  subText: PropTypes.node,
  type: PropTypes.string.isRequired,
  showTrialLoadingState: PropTypes.bool,
  showSubtitle: PropTypes.bool
}, upgradeDataPropsInterface);
export default ActivationSuccessModal;